import { Box, Grid, Typography } from "@mui/material";
import { useEffect } from "react";
import MenuService from "../../components/Menu/menuService";

const AboutCollecticos = () => {
  const boldWeight = 700;
  const titleStyle = { fontWeight: boldWeight, fontSize: "2rem !important" };

  const { selectPage } = MenuService();

  useEffect(() => {
    selectPage("cookie-policy");
  }, []);

  return (
    <Grid
      item
      container
      direction="column"
      alignItems={"center"}
      sx={{ width: "100%", height: "100%", backgroundColor: "white" }}
    >
      <Grid
        item
        container
        sx={{
          maxWidth: "1200px !important",
          paddingTop: "50px",
          paddingBottom: "50px",
          backgroundColor: "white",
        }}
        direction="column"
        rowSpacing={1}
        alignItems={"left"}
      >
        <Grid item>
          <Typography variant="body1">
            <Box component="span" fontWeight={boldWeight}>
              About Collecticos
            </Box>
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AboutCollecticos;
